<template>
  <div class="portrait" v-loading="portraitLoading">
          <el-tabs v-model="portraitName" @tab-click="portraitTabClick">
                <el-tab-pane label="观众画像" name="观众画像">
                  <div class="summary">
                    <i>画像总结</i>
                    <span v-for="(item,i) in darenWfan?.distributions" :key="i">{{item.image[0]}}</span>
                    <!-- <span>男性居多</span>
                    <span>广东，江苏，浙江居多</span>
                    <span>苹果手机较多</span>
                    <span>上海居多</span> -->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="粉丝画像" name="粉丝画像">
                  <div class="summary">
                    <i>画像总结</i>
                    <span v-for="(item,i) in darenFansdist?.distributions" :key="i">{{item.image[0]}}</span>
                    <!-- <span>18到23岁居多</span>
                    <span>男性居多</span>
                    <span>广东，江苏，浙江居多</span>
                    <span>苹果手机较多</span>
                    <span>上海居多</span>
                    <span>观看频次1次以下居多</span> -->
                  </div>
                </el-tab-pane>
                <el-tab-pane label="铁粉画像" name="铁粉画像">
                  <div class="summary">
                    <i>画像总结</i>
                    <span v-for="(item,i) in darenFansdist?.distributions" :key="i">{{item.image[0]}}</span>
                    <!-- <span>18到23岁居多</span>
                    <span>男性居多</span>
                    <span>广东，江苏，浙江居多</span>
                    <span>苹果手机较多</span>
                    <span>上海居多</span>
                    <span>观看频次1次以下居多</span> -->
                  </div>
                </el-tab-pane>
          </el-tabs>
          <!-- 观众画像/粉丝画像 -->
          <div class="audiencePortraitContainer clear">
            <div class="chart" v-if="sexDistributionData.data[1]?.value">
              <div class="chartTitle"><span>性别分布</span></div>
              <RingChart :ringChartInfo="sexDistributionData" ref="eChart1"></RingChart>
              <div class="sexType clear">
                <span>{{sexDistributionData.data[1].value}}%</span>
                <span>{{sexDistributionData.data[0].value}}%</span>
              </div>
            </div>
            <div class="chart">
              <div class="chartTitle"><span>年龄分布</span></div>
              <BarChart :barChartInfo="ageDistributionData" ref="eChart2"></BarChart>
            </div>
            <div class="chart" style="position:relative;">
              <div class="chartTitle"><span>全国省份分布</span></div>
              <ChinaChart :chartOption="companyOption" ref="eChart3"></ChinaChart>
              <div class="chartChinaDes"><i>{{Math.max.apply(null,chinaData?.map(x=>x?.value))}}%</i><span></span><i>{{Math.min.apply(null,chinaData?.map(x=>x?.value))}}%</i></div>
            </div>
            <div class="chart">
              <div class="chartTitle top">
                <span>地域占比 TOP10</span>
                <el-radio-group class="tab clear" v-model="areaTab" @change="areaChange">
                  <el-radio-button label="省份">省份</el-radio-button>
                  <el-radio-button label="城市">城市</el-radio-button>
                </el-radio-group>
              </div>
              <BarChart :barChartInfo="areaDistributionData" ref="echart4" v-loading="loadingObj.top10Loading"></BarChart>
              <!-- <div id="areaDistribution"></div> -->
            </div>
            <div class="chart">
              <div class="chartTitle"><span>城市等级分布</span></div>
              <BarChart :barChartInfo="cityLevelBarChartData" ref="cityLevelBarChart"></BarChart>
            </div>
            <div class="chart">
              <div class="chartTitle"><span>兴趣分布</span></div>
              <BarChart :barChartInfo="interestsBarChartData" ref="interestsBarChart"></BarChart>
            </div>
            <div class="chart whole-row">
              <div class="chartTitle"><span>八大人群分布</span></div>
              <BarChart :barChartInfo="crowdBarChartData" ref="crowdBarChart"></BarChart>
            </div>
            <div class="chart whole-row">
              <div class="chartTitle"><span>设备分布</span></div>
              <RingChart :ringChartInfo="equipmenDistributionData" ref="eChart5"></RingChart>
            </div>
            <div class="chart" v-if="isChart6">
              <div class="chartTitle"><span>近30天粉丝观看频次</span></div>
              <RingChart :ringChartInfo="fansWatchDistributionData" ref="eChart6"></RingChart>
            </div>
          </div>
  </div>

</template>

<script>
  import RingChart from "../../../components/Echart/RingChart.vue";
  import BarChart from "../../../components/Echart/BarChart.vue";

  import ChinaChart from "../../../components/Echart/ChinaChart.vue";
  import {
    mergeWith
  } from "lodash";
  export default {
    name: "AudiencePortrait",
    props: [],
    data() {
      return {
        darenID:'',
        portraitName:'观众画像',
        darenWfan:{},
        darenFansdist:{},
        isChart6:true,
        areaTab: "省份",
        sexDistributionData:{
            nodeId:'sexDistribution',//节点
            data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
            color:["#ff5c00","#40a0fc"],
            guideline:true,
            tooltipName:'粉丝总量',
            unit:'%'
        },
        ageDistributionData: {
          //年龄分布
          nodeId: "ageDistribution", //节点
          data: [20, 54, 30, 10, 5, 5], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: ["0-18", "18-23", "24-30", "31-40", "41-50", "50+"],
          min: 0, //y轴的最小值
          max: 60, //y轴最大值
          interval: 20, //值之间的间隔
          yAxisName: "占比",
          tooltipName: "年龄占比",
          unit: "%",
        },
        equipmenDistributionData: {
          //设备分布
          nodeId: "equipmenDistribution", //节点
          data: [{
              value: 18.5,
              name: "华为"
            },
            {
              value: 22.8,
              name: "小米"
            },
            {
              value: 27.0,
              name: "vivo"
            },
            {
              value: 31.8,
              name: "iphone"
            },
          ], //数据, //数据
          color: ["#2074ff",
            "#38a1ff",
            "#77bfff",
            "#a7d6ff",
            "#d0e9ff",
            "#def0ff",],
          xAxisData: ["0-18", "18-23", "24-30", "31-40", "41-50", "50+"],
          min: 0, //y轴的最小值
          max: 60, //y轴最大值
          interval: 20, //值之间的间隔
          yAxisName: "占比",
          tooltipName: "年龄占比",
          unit: "%",
          guideline: true, //引导线
        },
        fansWatchDistributionData: {
          //近30天粉丝观看频次
          nodeId: "fansWatchDistribution", //节点
          data: [{
              value: 18.5,
              name: "华为"
            },
            {
              value: 22.8,
              name: "小米"
            },
            {
              value: 27.0,
              name: "vivo"
            },
            {
              value: 31.8,
              name: "iphone"
            },
          ], //数据, //数据
          color: ["#2074ff",
            "#38a1ff",
            "#77bfff",
            "#a7d6ff",
            "#d0e9ff",
            "#def0ff",],
          xAxisData: ["0-18", "18-23", "24-30", "31-40", "41-50", "50+"],
          min: 0, //y轴的最小值
          max: 60, //y轴最大值
          interval: 20, //值之间的间隔
          yAxisName: "占比",
          tooltipName: "年龄占比",
          unit: "%",
          guideline: true, //引导线
        },
        areaDistributionData: {
          //地域占比 TOP10
          nodeId: "areaDistribution", //节点
          data: [12, 7, 8, 9, 12, 23, 3, 1, 6], //数据
          color: ["#ff5c00", "#40a0fc"],
          xAxisData: [
            "广东",
            "浙江",
            "河南",
            "江苏",
            "江西",
            "湖南",
            "福建",
            "湖北",
            "安徽",
          ],
          min: 0, //y轴的最小值
          max: 15, //y轴最大值
          interval: 5, //值之间的间隔
          yAxisName: "占比",
          tooltipName: "年省份占比",
          unit: "%",
        },
        companyOption: {}, // 企业图表参数
        chinaData: [
          //全国省份分布
          {
            name: "北京",
            value: 11.1
          },
          {
            name: "上海",
            value: 7.6
          },
          {
            name: "四川",
            value: 6.4
          },
          {
            name: "福建",
            value: 26.7
          },
          {
            name: "新疆",
            value: 0.9
          },
          {
            name: "河南",
            value: 6.7
          },
          {
            name: "贵州",
            value: 1.9
          },
          {
            name: "广西",
            value: 1.9
          },
        ],
        cityLevelBarChartData: {
          nodeId: 'cityLevelBarChart',
          yAxisName: "占比",
          tooltipName: "城市等级分布",
          unit: "%",
        },
        interestsBarChartData: {
          nodeId: 'interestsBarChart',
          yAxisName: "占比",
          tooltipName: "兴趣分布",
          unit: "%",
        },
        crowdBarChartData: {  // 八大人群分布
          nodeId: 'crowdBarChart',
          unit: "%",
          yAxisName: "占比",
          tooltipName: "八大人群占比",
        },
        portraitLoading: false,
        loadingObj: {
          top10Loading: false
        }
      };
    },
    computed: {},
    methods: {
      areaChange(tab){
        this.areaTab=tab
        this.changAllEchare("onlyEchart4")
      },
      portraitTabClick(tab){
        if(tab.$el.id==="pane-观众画像"){
          this.portraitName="观众画像"
        }else if(tab.$el.id==="pane-粉丝画像"){
          this.portraitName="粉丝画像"
        }else if(tab.$el.id==="pane-铁粉画像"){
          this.portraitName="铁粉画像"
        }
        this.changAllEchare()
      },

      changAllEchare(updateType = "all"){ //all更新所有的图表 onlyEchart4仅更新地域占比 TOP10
        updateType === "onlyEchart4" ? this.loadingObj.top10Loading = true : this.portraitLoading = true
        let tooltip =  {
            trigger: "item", // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用
            // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
            // 使用函数模板  传入的数据值 -> value: number | Array
            formatter: function (val) {
              let vals = val.value;
              if (isNaN(vals)) {
                vals = 0;
              }
              return val.name + ":" + vals + "%";
            }
          }
        if(this.portraitName==="观众画像"){
          this.$api.getData.getDarenWfan('/'+this.darenID, false).then((res) => {
            let data = res.data.data?.distributions
            this.darenWfan = res.data.data
            let cur = data.find(x => x.type_display === '性别分布')

            if(updateType !== "onlyEchart4") {
              //性别分布
              let man = parseInt(cur?.distribution_list?.find(x=>x.distribution_key=="male")?.distribution_value)
              let woman = parseInt(cur?.distribution_list?.find(x=>x.distribution_key=="female")?.distribution_value)
              // this.sexDistributionData.data[1].value=(man/(man+woman)).toFixed(3)*100
              // this.sexDistributionData.data[0].value = 100-(man/(man+woman)).toFixed(3)*100
              this.sexDistributionData.data[1].value=((man/(man+woman))*100).toFixed(1)-0
              this.sexDistributionData.data[0].value =((woman/(man+woman))*100).toFixed(1)-0
              this.$nextTick(() => {
                this.$refs.eChart1?.ringChart(this.sexDistributionData)
              })
              //年龄分布
              let ageData = []
              let ageDistributionData = []
              let agexAxisData = ["18-23", "24-30", "31-40", "41-50", "50+",]
              let ageSum=0
              cur = data.find(x => x.type_display === '年龄分布')
              agexAxisData.forEach(element => {
                cur?.distribution_list.forEach(function(item){
                  if(item.distribution_key == element){
                  ageData.push(parseInt(item.distribution_value))
                  }
                });
              })
              ageData.forEach(function(item,i){
                ageSum+=item
              })
              ageData.forEach(function(item,i){
                ageDistributionData.push(((item/ageSum)*100).toFixed(1)-0)
              })
              this.ageDistributionData.xAxisData=agexAxisData
              this.ageDistributionData.data=ageDistributionData
              this.ageDistributionData.min=0
              this.ageDistributionData.max=80
              this.ageDistributionData.interval=20
              this.$nextTick(() => {
                this.$refs.eChart2?.barChart(this.ageDistributionData)
              })


              //设备分布
              let equiDistributionData = []
              let equiSum=0
              cur = data.find(x => x.type_display === '设备品牌分布')
              cur?.distribution_list.forEach(function(item,i){
                equiSum+=parseInt(item.distribution_value)
              })
              cur?.distribution_list.forEach(function(item,i){
                if(item.distribution_value>1000){
                  let equiData = {
                    value: ((item.distribution_value/equiSum)*100).toFixed(2)-0,
                    name: item.distribution_key
                  }
                  equiDistributionData.push(equiData)
                }
              })
              this.equipmenDistributionData.data=equiDistributionData
              this.$nextTick(() => {
                this.$refs.eChart5?.ringChart(this.equipmenDistributionData)
              })
              // 城市等级分布
              cur = data.find(x => x.type_display === '城市等级分布')
              let total = cur?.distribution_list.reduce((prev, cur) => {
                return prev + cur.distribution_value * 1
              }, 0)
              cur?.distribution_list.sort((a, b) => b.distribution_value - a.distribution_value)
              this.cityLevelBarChartData = {
                ...this.baseBarChart,
                ...this.cityLevelBarChartData,
                xAxisData: cur?.distribution_list.map(x => x.distribution_key),
                data: cur?.distribution_list.map(x => (x.distribution_value / total * 100).toFixed(1))
              }
              this.$nextTick(() => {
                this.$refs.cityLevelBarChart.barChart(this.cityLevelBarChartData)
              })
              // 兴趣分布
              cur = data.find(x => x.type_display === '兴趣分布')
              total = cur?.distribution_list.reduce((prev, cur) => {
                return prev + cur.distribution_value * 1
              }, 0)
              cur?.distribution_list.sort((a, b) => b.distribution_value - a.distribution_value)
              this.interestsBarChartData = {
                ...this.baseBarChart,
                ...this.interestsBarChartData,
                xAxisData: cur?.distribution_list.map(x => x.distribution_key),
                data: cur?.distribution_list.map(x => (x.distribution_value / total * 100).toFixed(1))
              }
              this.$nextTick(() => {
                this.$refs.interestsBarChart.barChart(this.interestsBarChartData)
              })
              // 八大人群分布
              cur = data.find(x => x.type_display === '八大人群分布')
              total = cur?.distribution_list.reduce((prev, cur) => {
                return prev + cur.distribution_value * 1
              }, 0)
              cur.distribution_list = cur?.distribution_list.sort((a,b)=>b.distribution_value - a.distribution_value)
              this.crowdBarChartData = {
                ...this.baseBarChart,
                ...this.crowdBarChartData,
                xAxisData: cur?.distribution_list.map(x => x.distribution_key),
                data: cur?.distribution_list.map(x => (x.distribution_value / total * 100).toFixed(1))
              }
              this.$nextTick(() => {
                this.$refs.crowdBarChart.barChart(this.crowdBarChartData)
              })

              // 近30天粉丝观看频次
              cur = data.find(x => x.type_display === '观看频率分布')
              if(!cur||cur?.distribution_list.length<=0){
                this.isChart6=false
              }else{
                this.isChart6=true
                let fansWDistributionData = []
                let fansWSum=0
                cur?.distribution_list.forEach(function(item,i){
                  fansWSum+=parseInt(item.distribution_value)
                })
                cur?.distribution_list.forEach(function(item,i){
                  let fansWData = {
                      value: ((item.distribution_value/fansWSum)*100).toFixed(2)-0,
                      name: item.distribution_key
                  }
                  fansWDistributionData.push(fansWData)
                })
                this.fansWatchDistributionData.data=equiDistributionData
                this.$nextTick(() => {
                  this.$refs.eChart6?.ringChart(this.fansWatchDistributionData)
                })
              }
            }

            //省份/城市
            let chart4Arr=[]
            let chart4ArrMax
            let chart4Sum=0
            let top10Data=[]
            let top10xAxisData=[]
            if(this.areaTab==="省份"){
              cur = data.find(x => x.type_display === '省份分布')
              chart4Arr =cur?.distribution_list
              chart4Arr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-1
                chart4Sum+=item.distribution_value
              })
              //前十排序
              for(let i =0;i<chart4Arr.length;i++){
                for(let j=i;j<chart4Arr.length;j++){
                  if(chart4Arr[i].distribution_value<chart4Arr[j].distribution_value){
                      chart4ArrMax=chart4Arr[j];
                      chart4Arr[j]=chart4Arr[i];
                      chart4Arr[i]=chart4ArrMax;
                  }
                }
              }
              chart4Arr.forEach(function(item,i){
                if(i<10){
                  top10xAxisData.push(item.distribution_key)
                  top10Data.push(((item.distribution_value/chart4Sum)*100).toFixed(1)-0)
                }
              })
              this.areaDistributionData.data=top10Data
              this.areaDistributionData.xAxisData=top10xAxisData
              this.$nextTick(() => {
                this.$refs.echart4.barChart(this.areaDistributionData)
              })
            }else if(this.areaTab==="城市"){
              cur = data.find(x => x.type_display === '城市分布')
              chart4Arr =cur?.distribution_list
              chart4Arr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-1
                chart4Sum+=item.distribution_value
              })
              //前十排序
              for(let i =0;i<chart4Arr.length;i++){
                for(let j=i;j<chart4Arr.length;j++){
                  if(chart4Arr[i].distribution_value<chart4Arr[j].distribution_value){
                      chart4ArrMax=chart4Arr[j];
                      chart4Arr[j]=chart4Arr[i];
                      chart4Arr[i]=chart4ArrMax;
                  }
                }
              }
              chart4Arr.forEach(function(item,i){
                if(i<10){
                  top10xAxisData.push(item.distribution_key)
                  top10Data.push(((item.distribution_value/chart4Sum)*100).toFixed(1)-0)
                }
              })
              this.areaDistributionData.data=top10Data
              this.areaDistributionData.xAxisData=top10xAxisData
              this.$nextTick(() => {
                this.$refs.echart4.barChart(this.areaDistributionData)
              })
            }

            if(updateType === "onlyEchart4") {
              // this.portraitLoading = false
              this.loadingObj.top10Loading = false
            }

            if(updateType !== "onlyEchart4") {
              //全国
              cur = data.find(x => x.type_display === '省份分布')
              let allChinaArr=cur?.distribution_list
              let allChinaChartData=[]
              let allChinaSum=0
              allChinaArr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-0
                allChinaSum+=item.distribution_value
              })
              allChinaArr.forEach(function(item,i){
                allChinaChartData.push({
                  name: item.distribution_key,
                  value: ((item.distribution_value/allChinaSum)*100).toFixed(1)-0
                  })
              })
              this.chinaData = allChinaChartData
              this.companyViewChart(this.chinaData);
            }
          })

        }else if(this.portraitName==="粉丝画像" || this.portraitName==="铁粉画像"){
          let author_type = 0
          if(this.portraitName==="粉丝画像"){
            author_type = 1
          }else if(this.portraitName==="铁粉画像"){
            author_type = 5
          }
          this.$api.getData.getDarenFansdist(`/${this.darenID}?platform_channel=1&author_type=${author_type}`, false).then((res) => {
            let data = res.data.data?.distributions
            this.darenFansdist = res.data.data
            let cur = data.find(x => x.type_display === '性别分布')
            if(updateType !== "onlyEchart4") {
              //性别分布
              let man = parseInt(cur?.distribution_list?.find(x=>x.distribution_key=="male")?.distribution_value)
              let woman = parseInt(cur?.distribution_list?.find(x=>x.distribution_key=="female")?.distribution_value)
              this.sexDistributionData.data[1].value=((man/(man+woman))*100).toFixed(1)-0
              this.sexDistributionData.data[0].value =((woman/(man+woman))*100).toFixed(1)-0
              // this.sexDistributionData.data[0].value=(man/(man+woman)).toFixed(3)*100
              // this.sexDistributionData.data[1].value = 100-(man/(man+woman)).toFixed(3)*100
              this.$nextTick(() => {
                this.$refs.eChart1?.ringChart(this.sexDistributionData)
              })

              //年龄分布
              let allData = []
              let ageData = []
              let ageDistributionData = []
              let agexAxisData = ["18-23", "24-30", "31-40", "41-50", "50+",]
              let ageSum=0
              cur = data.find(x => x.type_display === '年龄分布')
              // cur?.distribution_list.filter(x=>x.)
              agexAxisData.forEach(element => {
                cur?.distribution_list.forEach(function(item){
                  if(item.distribution_key == element){
                  ageData.push(parseInt(item.distribution_value))
                  }
                });
              })
              cur?.distribution_list.forEach(function(item){
                  allData.push(parseInt(item.distribution_value))
                });
              allData.forEach(function(item,i){
                ageSum+=item
              })
              ageData.forEach(function(item,i){
                ageDistributionData.push(((item/ageSum)*100).toFixed(1)-0)
              })
              this.ageDistributionData.xAxisData=agexAxisData
              this.ageDistributionData.data=ageDistributionData
              this.ageDistributionData.min=0
              this.ageDistributionData.max=80
              this.ageDistributionData.interval=20
              this.$nextTick(() => {
                this.$refs.eChart2.barChart(this.ageDistributionData)
              })

              //设备分布
              let equiDistributionData = []
              let equiSum=0
              cur = data.find(x => x.type_display === '设备品牌分布')
              cur?.distribution_list.forEach(function(item,i){
                equiSum+=parseInt(item.distribution_value)
              })
              cur?.distribution_list.forEach(function(item,i){
                let equiData = {
                  value: ((item.distribution_value/equiSum)*100).toFixed(2)-0,
                  name: item.distribution_key
                }
                equiDistributionData.push(equiData)
              })
              this.equipmenDistributionData.data=equiDistributionData
              this.$nextTick(() => {
                this.$refs.eChart5?.ringChart(this.equipmenDistributionData)
              })

              // 近30天粉丝观看频次
              cur = data.find(x => x.type_display === '观看频率分布')
              if(!cur || cur?.distribution_list.length<=0){
                this.isChart6=false
              }else{
                this.isChart6=true
                let fansWDistributionData = []
                let fansWSum=0
                cur?.distribution_list.forEach(function(item,i){
                  fansWSum+=parseInt(item.distribution_value)
                })
                cur?.distribution_list.forEach(function(item,i){
                  let fansWData = {
                      value: ((item.distribution_value/fansWSum)*100).toFixed(2)-0,
                      name: item.distribution_key
                  }
                  fansWDistributionData.push(fansWData)
                })
                this.fansWatchDistributionData.data=equiDistributionData
                this.$nextTick(() => {
                  this.$refs.eChart6?.ringChart(this.fansWatchDistributionData)
                })
              }
            }


            //省份/城市
            let chart4Arr=[]
            let chart4ArrMax
            let chart4Sum=0
            let top10Data=[]
            let top10xAxisData=[]
            if(this.areaTab==="省份"){
              cur = data.find(x => x.type_display === '省份分布')
              chart4Arr =cur?.distribution_list
              chart4Arr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-1
                chart4Sum+=item.distribution_value
              })
              //前十排序
              for(let i =0;i<chart4Arr.length;i++){
                for(let j=i;j<chart4Arr.length;j++){
                  if(chart4Arr[i].distribution_value<chart4Arr[j].distribution_value){
                      chart4ArrMax=chart4Arr[j];
                      chart4Arr[j]=chart4Arr[i];
                      chart4Arr[i]=chart4ArrMax;
                  }
                }
              }
              chart4Arr.forEach(function(item,i){
                if(i<10){
                  top10xAxisData.push(item.distribution_key)
                  top10Data.push(((item.distribution_value/chart4Sum)*100).toFixed(1)-0)
                }
              })
              this.areaDistributionData.data=top10Data
              this.areaDistributionData.xAxisData=top10xAxisData
              this.$nextTick(() => {
                this.$refs.echart4.barChart(this.areaDistributionData)
              })
            }else if(this.areaTab==="城市"){
              cur = data.find(x => x.type_display === '城市分布')
              chart4Arr =cur?.distribution_list
              chart4Arr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-1
                chart4Sum+=item.distribution_value
              })
              //前十排序
              for(let i =0;i<chart4Arr.length;i++){
                for(let j=i;j<chart4Arr.length;j++){
                  if(chart4Arr[i].distribution_value<chart4Arr[j].distribution_value){
                      chart4ArrMax=chart4Arr[j];
                      chart4Arr[j]=chart4Arr[i];
                      chart4Arr[i]=chart4ArrMax;
                  }
                }
              }
              chart4Arr.forEach(function(item,i){
                if(i<10){
                  top10xAxisData.push(item.distribution_key)
                  top10Data.push(((item.distribution_value/chart4Sum)*100).toFixed(1)-0)
                }
              })
              this.areaDistributionData.data=top10Data
              this.areaDistributionData.xAxisData=top10xAxisData
              this.$nextTick(() => {
                this.$refs.echart4.barChart(this.areaDistributionData)
              })
            }
            if(updateType === "onlyEchart4") {
              // this.portraitLoading = false
              this.loadingObj.top10Loading = false
            }

            if(updateType !== "onlyEchart4") {
              //全国
              cur = data.find(x => x.type_display === '省份分布')
              let allChinaArr=cur?.distribution_list
              let allChinaChartData=[]
              let allChinaSum=0
              allChinaArr.forEach(function(item,i){
                item.distribution_value=item.distribution_value-0
                allChinaSum+=item.distribution_value
              })
              allChinaArr.forEach(function(item,i){
                allChinaChartData.push({
                  name: item.distribution_key,
                  value: ((item.distribution_value/allChinaSum)*100).toFixed(1)-0
                  })
              })
              this.chinaData = allChinaChartData
              this.companyViewChart(this.chinaData);
            }

          })
        }

      },

      companyViewChart(chinaData) {
        this.chinaMapShow = true;
        this.companyOption = mergeWith({}, self.companyOption, {
          // 提示框组件
          tooltip: {
            trigger: "item", // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用
            // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
            // 使用函数模板  传入的数据值 -> value: number | Array
            formatter: function (val) {
              let vals = val.value;
              if (isNaN(vals)) {
                vals = 0;
              }
              return val.name + ":" + vals + "%";
            },
            confine: true, //浮窗不超出屏幕范围
            textStyle: {
              fontSize: 12,
              color: "#333",
            },
            backgroundColor: "#fff",
            borderRadius: 4,
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
              lineStyle: {
                // 直线指示器样式设置
                color: "#333",
                width: 0.2,
                type: "solid",
              },
              z: 2, //竖线在圆圈后面
            },
            extraCssText: "box-shadow:0 0 18px rgba(0,0,0,0.2)", //提示框阴影
          },
          // 视觉映射组件
          visualMap: {
            type: "continuous", // continuous 类型为连续型  piecewise 类型为分段型
            show: false, // 是否显示 visualMap-continuous 组件 如果设置为 false，不会显示，但是数据映射的功能还存在
            // 指定 visualMapContinuous 组件的允许的最小/大值。'min'/'max' 必须用户指定。
            // [visualMap.min, visualMax.max] 形成了视觉映射的『定义域』
            min: 0.1,
            max: 11.1,
            top: 20,
            left: 20,
            // 文本样式
            // textStyle: {
            //   fontSize: 14,
            //   color: '#0d8cd8'
            // },
            realtime: true, // 拖拽时，是否实时更新
            calculable: false, // 是否显示拖拽用的手柄
            // 定义 在选中范围中 的视觉元素
            inRange: {
              color: [
                "#d5ecff",
                "#c5e4ff",
                "#b2dbff",
                "#90cbff",
                "#8cc9ff",
                "#77bfff",
                "#53aeff",
                "#38a1ff",
              ], // 图元的颜色
            },
          },
          series: [{
            type: "map", // 类型
            // 系列名称，用于tooltip的显示，legend 的图例筛选 在 setOption 更新数据和配置项时用于指定对应的系列
            name: "中国地图",
            mapType: "china", // 地图类型
            // 是否开启鼠标缩放和平移漫游 默认不开启 如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move' 设置成 true 为都开启
            roam: true,
            // 图形上的文本标签
            label: {
              show: false, // 是否显示对应地名
            },
            // 地图区域的多边形 图形样式
            itemStyle: {
              areaColor: "#e0f1ff", // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
              borderWidth: 0.5, // 描边线宽 为 0 时无描边
              borderColor: "#fff", // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
              borderType: "solid", // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
            },
            // 高亮状态下的多边形和标签样式
            emphasis: {
              label: {
                show: true, // 是否显示标签
                color: "#333", // 文字的颜色 如果设置为 'auto'，则为视觉映射得到的颜色，如系列色
              },
              itemStyle: {
                areaColor: "#f2cf44", // 地图区域的颜色
              },
            },
            // 自定义地区的名称映射
            // nameMap: name,
            // 地图系列中的数据内容数组 数组项可以为单个数值
            // data: res.data.data
            data: chinaData,
            /*companyData 的数据格式如下
                this.companyData = [
                  {name:'北京',value:13},
                  {name:'上海',value:13},
                ]
              */
          }, ],
        });
        this.portraitLoading = false
      },
    },
    components: {
      ChinaChart,
      RingChart,
      BarChart,
    },
    watch: {},
    created(){
      this.darenID = this.$route.query.id
    },
    mounted() {
      this.changAllEchare()

    },
  };
</script>

<style scoped>
.portrait>>>.el-tabs__item.is-active {
    color: #FF6F28 !important;
}
  #cityLevelBarChart,
  #interestsBarChart,
  #crowdBarChart {
    margin-top: -4px;
    width: 100%;
    height: 230px;
  }
  #fansWatchDistribution,
  #equipmenDistribution {
    margin-top: 10px;
    width: 100%;
    height: 210px;
  }

  #sexDistribution {
    margin-top: -20px;
    width: 100%;
    height: 210px;
  }

  #ageDistribution,
  #areaDistribution {
    margin-top: -4px;
    width: 100%;
    height: 230px;
  }

  .chartChinaDes {
    position: absolute;
    bottom: 44px;
    left: 0px;
    width: 40px;
    height: 50px;
  }

  .chartChinaDes span {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 10px;
    height: 50px;
    background-image: linear-gradient(to bottom, #38a1ff, #e0f1ff);
  }

  .chartChinaDes i {
    position: absolute;
    top: -22px;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #5098d6;
    font-size: 12px;
    text-align: center;
  }

  .chartChinaDes i:nth-of-type(2) {
    top: auto;
    bottom: -22px;
  }

  .audiencePortraitContainer {
    margin-top: 30px;
    padding: 0 30px;
    box-sizing: border-box;
  }

  .audiencePortraitContainer .chart {
    float: left;
    width: 50%;
    height: 330px;
    border-top: 1px solid #f0f0f0;
    /* background: skyblue; */
  }
  .audiencePortraitContainer .whole-row {
    width: 100%;
  }

  .audiencePortraitContainer .chart .chartTitle {
    display: block;
    width: 100%;
    height: 74px;
  }

  .audiencePortraitContainer .chart .chartTitle span {
    line-height: 74px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }

  .sexType span {
    position: relative;
    float: left;
    width: 50%;
    margin-top: 10px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #40a0fc;
    text-align: center;
  }

  .sexType span::before {
    position: absolute;
    top: -18px;
    content: "男性占比";
    font-size: 12px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }


  .sexType span::after {
    position: absolute;
    top: -12px;
    left: 40px;
    content: "";
    width: 30px;
    height: 30px;
    background: url("../images/boy.png") no-repeat center;
  }

  .sexType span:nth-of-type(2) {
    color: #ff5c00;
  }

  .sexType span:nth-of-type(2)::before {
    content: "女性占比";
  }
  .sexType span:nth-of-type(2)::after {
    background-image: url("../images/girl.png");
  }

  .chartTitle .tab {
    float: right;
    margin-top: 16px;
  }

  .portrait .summary{
    border-top: 1px solid #F0F0F0;
    /* width: 802px; */
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 24px;
  }
  .portrait .summary i{
    display: block;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .portrait .summary span{
    margin-right: 24px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .portrait .summary span:nth-of-type(1){
    margin-left: 9px;
  }

</style>